import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/tokens.css';
import './styles/app.css';

const container = document.getElementById('racine');
if (container === null) {
  throw new Error("Element racine introuvable dans index.html.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
